<template>
  <div class="new-content-ownership">
    <ContentBlock>
      <div slot="instructions">
        <h5>{{ $t("Before getting started") }}</h5>
        <i18n
          tag="p"
          path="Before you get started, please read our {guidelink} to familiarize yourself with the process of adding your title to SpringboardVR and our {guidelinelink} to ensure your title meets our requirements and standards."
        >
          <a
            class="link-style"
            href="https://support.springboardvr.com/hc/en-us/articles/360011635274-Content-Creator-Setup-Guide"
            slot="guidelink"
            target="_blank"
            rel="noopener"
          >{{ $t("Content Distribution Guide").replace(' ', '&nbsp;') }}</a>
          <a
            class="link-style"
            href="https://support.springboardvr.com/hc/en-us/articles/360015797753-Content-Guidelines"
            slot="guidelinelink"
            target="_blank"
            rel="noopener"
          >{{ $t("Content Guidelines").replace(' ', '&nbsp;') }}</a>
        </i18n>
      </div>
      <div>
        <CDSGuide />
      </div>
    </ContentBlock>
    <ContentBlock :required="true">
      <template #instructions>
        <h5>{{ $t("Content Preview") }}</h5>
        <p>{{ $t("Your content title and cover image.") }}</p>
      </template>
      <template #default>
        <div class="basicform">
          <UIInput
            class="col-span-all"
            v-model="contentOwnership.title"
            :title="$t('Content Title')"
            required
          />
          <div>
            <UIFormItem
              :root="true"
              class="mb3"
              required
              :title="$t('Content Image')"
              :instructions="$t('This image will be seen by location operators and players when they preview your content.')"
            />
            <FileUploadWithThumbnail
              :ratio="46.5863"
              :maxFileSize="2 * 1000000"
              id="image"
              type="image"
              accept="image/*"
              :media="contentOwnership._imageBlob"
              instructions="2 MB maximum. Suggested size: 600x280 px."
              @input="media => contentOwnership._imageBlob = media"
              @clear="contentOwnership._imageBlob = null"
            />
          </div>
        </div>
      </template>
    </ContentBlock>
    <BottomBar
      :backRouterLink="{ name: 'content-ownerships' }"
      :actionText="$t('Start')"
      :valid="canStart"
      @save="start"
      :saving="isSaving"
    />
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component';
import BottomBar from '@/core/shared/components/BottomBar';
import ContentBlock from '@/core/shared/components/ContentBlock';
import FocusModeMixin from '@/core/shared/misc/FocusModeMixin';
import CDSGuide from './components/CDSGuide';
import UIButton from '@/core/shared/components/ui/UIButton';
import UIInput from '@/core/shared/components/ui/UIInput';
import UIFormItem from '@/core/shared/components/ui/UIFormItem';
import FileUploadWithThumbnail from '@/core/shared/components/FileUploadWithThumbnail';

@Component({
  components: {
    BottomBar,
    ContentBlock,
    CDSGuide,
    UIInput,
    FileUploadWithThumbnail,
    UIFormItem,
    UIButton,
  },
})
export default class NewContentOwnershipsRoute extends mixins(FocusModeMixin) {
  contentOwnership = {
    title: null,
    _imageBlob: null,
  };

  isSaving = false

  created () {
    this.$store.commit('setTitle', this.$t('Add Content'));
  }

  get canStart () {
    return !!this.contentOwnership.title && !!this.contentOwnership._imageBlob;
  }

  async start () {
    this.isSaving = true;
    this.$store.commit('setLoadingOverlay', true);
    try {
      const contentOwnership = await this.$store.dispatch('createContentOwnership', this.contentOwnership);
      this.$router.push({ name: 'pending-content-ownership', params: { contentOwnershipId: contentOwnership.id } });
    } finally {
      this.isSaving = false;
      this.$store.commit('setLoadingOverlay', false);
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "core/shared/styles";

.new-content-ownership {
  @apply --container;
  padding-top: var(--spacingMd);
}
.basicform {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: var(--spacingMd);
}
</style>
